/**
 *
 * @description 兑换第三方优惠卡，需要记录用户邮箱、使用地区等信息
 * @time 2022/6/17 17:47
 *
 */

import React, { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { inject } from 'mobx-react';
import styles from './index.module.less';
import SubmitBtn from '@/components/SubmitBtn';
import MiddleModal from '@/components/MiddleModal';
import { message, Input, Select } from 'antd';
import validator from '@/utils/validator';

const Index = inject(
  'area',
  'gold',
  'app'
)(
  forwardRef((props, ref) => {
    const { LANG, allCountry } = props.area;
    const { exChangeThirdGiftCard } = props.gold;
    const { productDetail, onExchangeProductSuccess } = props;
    const [visible, setVisible] = useState(false);
    const [email, setEmail] = useState('');
    const [area, setArea] = useState('');

    useImperativeHandle(ref, () => ({
      toggleVisible,
    }));

    const productDetailArea = useMemo(() => {
      if (!productDetail || !productDetail.area) return [];
      return productDetail.area.map((o) => allCountry.find((i) => i.code === o)).filter((o) => !!o);
    }, [productDetail]);

    const toggleVisible = (visible) => {
      setVisible(visible);
      if (!visible) {
        setEmail('');
        setArea('');
      }
    };

    const handleSubmit = async () => {
      const validateEmail = validator({ type: 'email', val: email });
      if (!validateEmail) {
        message.warning(LANG['common.form.emailMsg']);
        return;
      }
      if (productDetailArea.length && area === '') {
        message.warning(LANG['product.selectAreaMsg']);
        return;
      }
      const data = {
        email,
        area,
        product_id: productDetail.id,
      };
      props.app.setGlobalValue('G_GlobalLoading', true);
      const { code } = await exChangeThirdGiftCard(data);
      props.app.setGlobalValue('G_GlobalLoading', false);
      if (code === 0) {
        toggleVisible(false);
        onExchangeProductSuccess?.();
      } else if (code === 5003) {
        const msg = LANG['product.redeemedMax']
          .replace('%d', productDetail.period)
          .replace('%t', productDetail.periodTime);
        message.warning(msg);
      } else if (code === 5004) {
        message.warning(LANG['product.exchangeBlackList']);
      } else if (code === 5005) {
        message.warning(LANG['product.notExist']);
      } else if (code === 16000) {
        message.warning(LANG['product.goldNotEnough']);
      } else {
        message.warning(code);
      }
    };

    return (
      <MiddleModal
        title={LANG['product.redemptionInfo']}
        footer={null}
        theme='float'
        visible={visible}
        wrapClassName={styles.submitModal}
        onCancel={() => toggleVisible(false)}
      >
        <div className={styles.thirdCardContent}>
          <div className={styles.formItem}>
            <p className={styles.key}>{LANG['product.labelCardEmail']}</p>
            <Input
              className={styles.input}
              onInput={(e) => setEmail(e.target.value)}
              placeholder={LANG['common.form.emailPlaceholder']}
            />
            <p className={styles.tips}>{LANG['product.labelCardEmailTips']}</p>
          </div>
          {productDetailArea.length ? (
            <div className={styles.formItem}>
              <p className={styles.key}>{LANG['product.labelCardArea']}</p>
              <Select
                className={styles.select}
                placeholder={LANG['product.selectedAreaPlaceholder']}
                onChange={(area) => setArea(area)}
              >
                {productDetailArea.map((o, k) => (
                  <Select.Option value={o.code} key={k}>
                    {o.name}
                  </Select.Option>
                ))}
              </Select>
              <p className={styles.tips}>{LANG['product.labelCardAreaTips']}</p>
            </div>
          ) : null}
        </div>
        <div className={styles.modalFooter}>
          <span className={styles.point}>
            {LANG['common.label.gold']}:{productDetail.points}
          </span>
          <div className={styles.btnGroup}>
            <SubmitBtn className={styles.cancel} onClick={() => toggleVisible(false)}>
              {LANG['common.btn.cancel']}
            </SubmitBtn>
            <SubmitBtn className={styles.submit} onClick={handleSubmit}>
              {LANG['common.btn.redeemNow']}
            </SubmitBtn>
          </div>
        </div>
      </MiddleModal>
    );
  })
);

export default Index;
